import { useGlobals } from "@/components/providers/globals-provider.tsx";
import { PROPERTY_DYNAMIC } from "@/features/sub-families/resources/constants.ts";

type Options = {
    productProperty: string;
    isDesign?: boolean;
    idx?: number;
    /** Used when globals.property is unset. SubFamilies → true, others → false */
    defaultOpenWhenNoProperty?: boolean;
};

export default function useFilterCollapseInitialOpen({
    productProperty,
    isDesign = false,
    idx = -1,
    defaultOpenWhenNoProperty = false,
}: Options): boolean {
    const { property } = useGlobals();

    const isOpenByProperty = property === productProperty;
    const isFirstPropertyOfNotDesign = !isDesign && idx === 0;
    const isSecondOpenByPropertyDynamicAndDesign = isDesign && property === PROPERTY_DYNAMIC && idx === 1;

    const positionalOpen = isFirstPropertyOfNotDesign || isSecondOpenByPropertyDynamicAndDesign;

    if (property) {
        return isOpenByProperty || positionalOpen;
    }

    return defaultOpenWhenNoProperty || positionalOpen;
}
